<template>
  <v-container fluid align-start ma-0 pa-2 class="epms9065-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve' //Retrieve
                    ]"
                  @btnRetrieve="btnRetrieve()"
                >
                  <template v-slot:body>
                    
                    <v-row no-gutters class="center pa-2 pb-0">
                      <!-- Year dropdownlist -->
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Year: </span>
                      <v-col cols="2">
                          <v-select
                            v-model="calYear"
                            :items="yearList"
                            item-value="calYear"
                            return-object
                            single-line                            
                            outlined
                            dense
                            label="Select"
                            @change="yearListChange()"
                          ></v-select>
                      </v-col>

                      <!-- Mon dropdownlist -->
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Month: </span>
                      <v-col cols="1">
                          <v-select
                            v-model="calMon"
                            :items="monList"
                            item-value="calMon"
                            return-object
                            single-line
                            outlined
                            dense
                            label="Select"
                            @change="monListChange()"
                          ></v-select>
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pa-1">
                <v-icon small color="blue">mdi-circle</v-icon>
                <span class="pa-1 subTitle">1.Not Yet Delivery Satus (Base on Material Need Date) </span>
              </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms9065" 
                    class="hipGridHeight2_1"
                    :ref="epms9065Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn caption="Division" width="10%" data-type="string" alignment="center" :allow-editing="false">
                        <DxColumn data-field="div2" caption="Item" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="div3" caption="Div" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>
                    <DxColumn data-field="mon1" caption="Mon1" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon2" caption="Mon2" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon3" caption="Mon3" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon4" caption="Mon4" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon5" caption="Mon5" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon6" caption="Mon6" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon7" caption="Mon7" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon8" caption="Mon8" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon9" caption="Mon9" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="mon10" caption="Mon10" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="total" caption="Total" width="8%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="rmk" caption="Remark" width="12%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxPaging :enabled="true" :page-size="20" />
                  </DxDataGrid>
                </v-col>
              </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pa-1">
                <v-icon small color="blue">mdi-circle</v-icon>
                <span class="pa-1 subTitle">2.Fabrication Satus (Base on PSD) </span>
              </v-col>
            </v-row>

            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms9065_2" 
                    class="hipGridHeight6_1"
                    :ref="epms9065Ref"
                    :data-source="gridMainList2" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    @cellPrepared="cellPrepared2"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn caption="Division" width="24%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="div1" caption="Report Item" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="div2" caption="Duration" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="div3" caption="Div" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="col1" caption="Total" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="Not Make Start" width="14%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="col2" caption="Value" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="col3" caption="%" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="Make Start" width="14%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="col4" caption="Value" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="col5" caption="%" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="Make Finish" width="14%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="col6" caption="Value" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="col7" caption="%" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="Paint Start" width="14%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="col8" caption="Value" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="col9" caption="%" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn caption="Paint Finish" width="14%" data-type="string" alignment="center" :allow-editing="false">
                      <DxColumn data-field="col10" caption="Value" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="col11" caption="%" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    </DxColumn>

                    <DxColumn data-field="rmk" caption="Remark" width="12%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="div1Cnt" caption="div1Cnt" width="2%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="div2Cnt" caption="div2Cnt" width="2%" data-type="string" alignment="center" :allow-editing="false"/>

                    <DxPaging :enabled="true" :page-size="20" />

                  </DxDataGrid>
                </v-col>
            </v-row>
            
            <v-row no-gutters>
              <v-col cols="12" class="pa-1">
                <v-icon small color="blue">mdi-circle</v-icon>
                <span class="pa-1 subTitle">3.Request Issue Date(Base on PSD)</span>
              </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms9065_3" 
                    class="hipGridHeight3_1"
                    :ref="epms9065Ref"
                    :data-source="gridMainList3" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                  >
                    <DxEditing :use-icons="true" mode="cell" />
                    <DxColumn data-field="div3" caption="Division" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="col1" caption="Not Make Start" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="col2" caption="Make Start" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="col3" caption="Make Finish" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="col4" caption="Paint Start" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="col5" caption="Paint Finish" width="7%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="col7" caption="Total" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="rmk" caption="Remark" width="10%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxPaging :enabled="true" :page-size="20" />

                  </DxDataGrid>
                </v-col>
            </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getYearFormat, getDateFormat, getFirstDate, getLastDate, getNumComma, getStringToDate, getDateToStringDte} from '@/utils/common.js'
import { epms9065 } from '@/api/view/hip/91/epms9065'
import { getYearList} from '@/api/view/hip/common/common'
// import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epms9065',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve'],
      epms9065Ref: 'epms9065Ref',
      gridMainList: [],
      gridMainList2: [],
      gridMainList3: [],
      yearList: ["2013","2014","2015","2016","2017","2018","2019","2020","2021","2022","2023","2024","2025","2026","2027","2028"],
      monList: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      makerCd: this.$store.state.user.makerCd,
      stDte: '',
      calYear: '',
      calMon : '',
      strMon: '',
      strMon1: '',
      strMon2: '',
      strMon3: '',
      strMon4: '',
      strMon5: '',
      strMon6: '',
      strMon7: '',
      strMon8: '',
      strMon9: '',
      strMon10: '',
      strMon11: '',
      strMon12: ''
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epms9065Ref)
    },
  },
  mounted() {
    this.init()
    //this.getList()
    //this.gridMainInstance.option('defaultPaging', false)
    //this.btnRetrieve()
  },
  methods: {
    init() {
      this.stDte = getFirstDate('m')
      this.calMon = this.monList[0] ;
    },
    async getMainList(){
      try {
        this.openLoading('searching')

        this.stDte = this.calYear + "-" + this.calMon + "-01"
        this.strMon = this.calYear + "-" + this.calMon

        let tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 4))
        this.strMon1 = this.strMon
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 1))
        this.strMon2 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 2))
        this.strMon3 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 3))
        this.strMon4 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 4))
        this.strMon5 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 5))
        this.strMon6 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 6))
        this.strMon7 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 7))
        this.strMon8 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 8))
        this.strMon9 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 9))
        this.strMon10 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 10))
        this.strMon11 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)
        
        tmpDte  = getDateFormat(this.getAddMonths(new Date(this.stDte.substr(0, 4), this.stDte.substr(5, 2), "01" ), 11))
        this.strMon12 = getDateFormat(new Date(tmpDte.substr(0, 4), parseInt(tmpDte.substr(5, 2)) - 1, 0)).substr(0,7)

        let params = {
          makerCd: this.$store.state.user.makerCd,
          stDte  : this.stDte
        }

        // console.log('St date', this.stDte )
        // console.log('Ed date', this.edDte )
        // console.log('strMon', this.strMon)
        // console.log('shipNo', this.shipNo)
        // console.log('block', this.block)
        
        await epms9065(params).then(res => {
          let list = [];
          let list2 = [];
          let list3 = [];
          let cnt = 1;
          res.list.forEach(e => {
            if(e.div === "10"){
              list.push(
              {
                id: cnt++ , div2 : e.div2, div3 : e.div3,  
                mon1: e.col1, mon2: e.col2, mon3: e.col3, mon4: e.col4,  mon5: e.col5, 
                mon6: e.col6, mon7: e.col7, mon8: e.col8, mon9: e.col9,  mon10: e.col10,
                total: e.col11, rmk: e.rmk
              })
            } 
            else if(e.div === "20"){
              let cnt2 = 1;
              list2.push(
              {
                id: cnt2++ , div1 : e.div1, div2 : e.div2, div3 : e.div3,
                col1: e.col1, col2: e.col2, col3: e.col3, col4: e.col4,  col5: e.col5, 
                col6: e.col6, col7: e.col7, col8: e.col8, col9: e.col9,  col10: e.col10,
                col11: e.col11, rmk: e.rmk, div1Cnt : e.div1Cnt, div2Cnt : e.div2Cnt
              })
            } else if(e.div === "31"){
              let cnt3 = 1;
              list3.push(
              {
                id: cnt3++ , div3 : e.div3, 
                col1: e.col1, col2: e.col2, col3: e.col3, col4: e.col4,  col5: e.col5, col7: e.col7, rmk: e.rmk
              })
            }
          }); 
          this.gridMainList = list
          this.gridMainList2 = list2
          this.gridMainList3 = list3
        })
      } finally {
        this.endLoading()
      }
    },
    //Get the day from based date after n months 
   getAddMonths(baseDte, intMons){
      let tmpDte = baseDte.setMonth(baseDte.getMonth() + intMons );
      return tmpDte
    },
    yearListChange(){
      this.calMon = this.monList[0]
    },

    monListChange(){
      this.btnRetrieve()
    },

    btnRetrieve(){
      this.gridMainList = []
      this.gridMainList2 = []
      this.gridMainList3 = []
      this.getMainList()
    },
    //cell merge
    cellPrepared(e){
      if(e.rowType === 'data'){
          if(e.column.caption === 'Item') 
            {
              if(e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'div2')){
                e.cellElement.setAttribute('rowspan', 2)
              }else {
                e.cellElement.style.display = 'none'
              }
          }
      } else {
        if(e.column.caption === 'Mon1'){
          e.cellElement.innerText = this.strMon1;
        }else if(e.column.caption === 'Mon2'){
          e.cellElement.innerText = this.strMon2;
        }else if(e.column.caption === 'Mon3'){
          e.cellElement.innerText = this.strMon3; 
        }else if(e.column.caption === 'Mon4'){
          e.cellElement.innerText = this.strMon4; 
        }else if(e.column.caption === 'Mon5'){
          e.cellElement.innerText = this.strMon5; 
        }else if(e.column.caption === 'Mon6'){
            e.cellElement.innerText = this.strMon6; 
        }else if(e.column.caption === 'Mon7'){
            e.cellElement.innerText = this.strMon7; 
        }else if(e.column.caption === 'Mon8'){
            e.cellElement.innerText = this.strMon8; 
        }else if(e.column.caption === 'Mon9'){
            e.cellElement.innerText = this.strMon9; 
        }else if(e.column.caption === 'Mon10'){
            e.cellElement.innerText = this.strMon10; 
        }
      }
    },
    cellPrepared2(e){
      
        if(e.rowType === 'data'){
              // if(e.column.caption === 'Report Item' || e.column.caption === 'div1Cnt' ) { 
          
              //     e.cellElement.setAttribute('rowspan', parseInt(e.component.cellValue(e.rowIndex + 1, 'div1Cnt')))

              //   }
              //       e.cellElement.setAttribute('rowspan', parseInt(e.component.cellValue(e.rowIndex + 1, 'div1Cnt')))
              //      // e.cellElement.setAttribute('rowspan', 10)
              // }
              // if(e.column.caption === 'Duration') 
              //   {
              //     if(e.value == e.component.cellValue(e.rowIndex + 1, e.column.dataField) && e.values[0] == e.component.cellValue(e.rowIndex + 1, 'div2')){
              //       e.cellElement.setAttribute('rowspan',2)
              //     }else {
              //       e.cellElement.style.display = 'none'
              //     }
              // }
          } 
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },
  }
}
</script>
<style lang="scss" scoped>
.epms9065-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }

  ::v-deep.text__dely-no {
    input {
      text-align: center;
    }
  }
}
</style>